module.exports = __webpack_public_path__ + "img/cloud_service_pic.c3cbb484.jpg";